import { isAfter, isBefore, type Interval, isWithinInterval } from 'date-fns';

export const isActivePeriod = (period: Interval) =>
  isWithinInterval(new Date(), period);

export const isFuturePeriod = (period: Interval) =>
  isAfter(period.start, new Date());

export const isPastPeriod = (period: Interval) =>
  isBefore(period.end, new Date());
